var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"loading"}},[_c('div',{staticClass:"loading-mask"},[_c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"loading-container"},[_c('v-progress-circular',{staticStyle:{"margin":"15px 15px 0px 0px"},attrs:{"indeterminate":true,"color":"primary","size":"25"}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }